import { PageLoadingProvider, PageLoadingFallback } from '@/components/layout/PageLoadingProvider'
import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useResultsAvailable } from '@/hooks/useResultsAvailable'
import { CandidateDataProvider } from '@/components/candidates/CandidateDataProvider'
import { SiteLayout } from '@/components/layout/SiteLayout'
import { HomePage } from '@/pages/HomePage'
import { StarterPage } from '@/pages/StarterPage'

const CandidatesPage = lazy(() =>
  import('@/pages/CandidatesPage').then((module) => ({ default: module.CandidatesPage })),
)
const ReportingPage = lazy(() =>
  import('@/pages/ReportingPage').then((module) => ({ default: module.ReportingPage })),
)
const ResultsPage = lazy(() =>
  import('@/pages/ResultsPage').then((module) => ({ default: module.ResultsPage })),
)
const ReportingVideosPage = lazy(() =>
  import('@/pages/ReportingVideosPage').then((module) => ({ default: module.ReportingVideosPage })),
)

export default function App() {
  const resultsAvailable = useResultsAvailable()
  const location = useLocation()
  return (
    <CandidateDataProvider>
      <PageLoadingProvider key={location.pathname}><SiteLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/tu-ciudad"
            element={<Navigate to="/candidatos" replace />}
          />
          <Route path="/tu-ciudad/*" element={<Navigate to="/candidatos" replace />} />
          <Route
            path="/candidatos"
            element={
              <Suspense fallback={<PageLoadingFallback />}>
                <CandidatesPage />
              </Suspense>
            }
          />
          <Route
            path="/candidatos/:slug"
            element={
              <Suspense fallback={<PageLoadingFallback />}>
                <CandidatesPage />
              </Suspense>
            }
          />
          <Route
            path="/resultados"
            element={
              <Suspense fallback={<PageLoadingFallback />}>
                {resultsAvailable ? <ResultsPage /> : <Navigate to="/" replace />}
              </Suspense>
            }
          />
          <Route
            path="/reporteria-ciudadana"
            element={
              <Suspense fallback={<PageLoadingFallback />}>
                <ReportingPage />
              </Suspense>
            }
          />
          <Route
            path="/reporteria-ciudadana/videos"
            element={
              <Suspense fallback={<PageLoadingFallback />}>
                <ReportingVideosPage />
              </Suspense>
            }
          />
          <Route
            path="*"
            element={
              <StarterPage
                title="Pagina no encontrada"
                description="La ruta solicitada no existe en el especial de Elecciones Seccionales 2027."
              />
            }
          />
        </Routes>
      </SiteLayout></PageLoadingProvider>
    </CandidateDataProvider>
  )
}
